<template>
  <dashboard>
    <template v-slot:content>
      <section>
        <b-container fluid>
          <div class="d-none" v-html="stringHtml"></div>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="7" md="7">
                    <h5 class="mt-2" @click="openPortList" v-text="Title"></h5>
                  </b-col>
                  <b-col lg="5" md="5">
                    <b-button
                      variant="outline-danger"
                      class="float-right mb-2"
                      @click="logoutNav"
                      id="logout-btn"
                    >
                      <img
                        src="../assets/images/Logout.svg"
                        class="out-hover"
                        alt
                      />
                      <img
                        src="../assets/images/Logout-white.svg"
                        alt
                        class="on-hover"
                      />&nbsp; Logout
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>
      <section class="fadein setting">
        <b-container fluid>
          <b-card no-body class="left-side">
            <b-tabs pills card vertical class="tab-text" v-model="tabIndex">
              <b-tab title="Profile Information" class="w-100">
                <b-card-text>
                  <h5 class="fw-normal mb-3">Profile Information</h5>
                  <div>
                    <b-form @submit.prevent>
                      <div>
                        <b-form-row>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-org-name"
                              >Organization Name</label
                            >
                            <b-form-input
                              type="text"
                              autocomplete="off"
                              v-model="
                                state.system.settings.store.organisation_name
                              "
                              id="input-org-name"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-store-name">Store Name</label>
                            <b-form-input
                              type="text"
                              autocomplete="off"
                              v-model="state.system.settings.store.name"
                              id="input-store-name"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                        </b-form-row>
                        <b-form-row>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-currency-name"
                              >Currency Name</label
                            >
                            <b-form-input
                              type="text"
                              autocomplete="off"
                              v-model="currency"
                              id="input-currency-name"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-time-zone">Time Zone</label>
                            <b-form-input
                              type="text"
                              autocomplete="off"
                              id="input-time-zone"
                              v-model="timezone"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                        </b-form-row>
                        <b-form-row>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-phone">Phone</label>
                            <b-form-input
                              type="number"
                              id="input-phone"
                              autocomplete="off"
                              placeholder="Enter Phone Number"
                              v-model="state.sessions.user.mobile"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-email">E-mail address</label>
                            <b-form-input
                              id="input-email"
                              type="email"
                              autocomplete="off"
                              v-model="state.sessions.user.email"
                              placeholder="Enter Email"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                        </b-form-row>
                        <b-form-row>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-first-name">First Name</label>
                            <b-form-input
                              id="input-first-name"
                              type="text"
                              autocomplete="off"
                              v-model="first_name"
                              placeholder="Enter First Name"
                              :disabled="$loading || state.system.isOffline"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-last-name">Last Name</label>
                            <b-form-input
                              id="input-last-name"
                              type="text"
                              autocomplete="off"
                              v-model="last_name"
                              placeholder="Enter Last Name"
                              :disabled="$loading || state.system.isOffline"
                            ></b-form-input>
                          </b-form-group>
                        </b-form-row>
                        <b-form-row>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-dob">Date of Birth</label>
                            <datepicker
                              placeholder="Select..."
                              input-class="form-control dob"
                              v-model="dob"
                              :format="customFormatter"
                              :disabled="state.system.isOffline"
                            ></datepicker>
                          </b-form-group>
                          <b-form-group class="col-md-4 mb-2">
                            <label for id="label-gender">Gender</label>
                            <b-form-select
                              id="input-gender"
                              class="form-control"
                              v-model="gender"
                              :disabled="state.system.isOffline"
                            >
                              <option value="" disabled
                                >Select your gender</option
                              >
                              <option value="male">Male</option>
                              <option value="female">Female</option>
                            </b-form-select>
                          </b-form-group>
                        </b-form-row>

                        <b-form-row>
                          <b-button
                            variant="primary"
                            class="mt-5"
                            style="width:auto"
                            @click="updateDetails"
                            :disabled="state.system.isOffline || $loading"
                            id="update-user-info"
                          >
                            <span v-if="!$loading">Update Information</span>
                            <b-spinner small v-if="$loading"></b-spinner>
                          </b-button>
                        </b-form-row>
                      </div>
                    </b-form>
                  </div>
                </b-card-text>
              </b-tab>

              <b-tab title="Change PIN">
                <b-card-text>
                  <h5 class="fw-normal mb-3">Change PIN</h5>
                  <form @submit.prevent>
                    <div class="step1" v-show="!isSeen">
                      <p>
                        Before you proceed, we need to confirm your identity.
                        <br />Please enter your current PIN below.
                      </p>
                      <b-form @submit.prevent>
                        <b-form-group class="col-md-4 p-0 pt-2 update-password">
                          <b-input-group>
                            <b-input-group-prepend>
                              <span class="input-group-text">
                                <b-link
                                  @click="viewPassword()"
                                  id="show-hide-password"
                                >
                                  <img
                                    src="../assets/images/hide-small.svg"
                                    alt
                                    v-show="isHide"
                                  />
                                  <img
                                    src="../assets/images/reveal-small.svg"
                                    alt
                                    v-show="!isHide"
                                  />
                                </b-link>
                              </span>
                            </b-input-group-prepend>
                            <input
                              type="password"
                              ref="password"
                              id="enter-current-pin"
                              class="LoginInput form-control"
                              size="lg"
                              maxlength="4"
                              :disabled="state.system.isOffline"
                              autofocus
                              :state="
                                $v.form.currentPin.$dirty
                                  ? !$v.form.currentPin.$error
                                  : null
                              "
                              v-model="$v.form.currentPin.$model"
                            />
                          </b-input-group>
                          <p class="error" v-show="isIncorrect == true">
                            <img src="../assets/images/alert.svg" alt />&nbsp;
                            Incorrect PIN. Please try again.
                          </p>
                        </b-form-group>
                        <b-button
                          type="submit"
                          class="mt-5 text-center"
                          variant="primary"
                          ref="submitBtn"
                          @click="checkPin()"
                          id="cont-btn-pin"
                          :disabled="
                            $v.form.currentPin.$invalid ||
                              state.system.isOffline
                          "
                        >
                          <span v-if="$loading == false">Continue</span>
                          <b-spinner small v-if="$loading == true"></b-spinner>
                        </b-button>
                      </b-form>
                      <!-- <h6 class="text-danger" v-show="isIncorrect">Incorrect PIN. Please try again.</h6> -->
                    </div>
                    <div class="step2" v-show="isSeen">
                      <h6>You may now set-up your new PIN.</h6>
                      <b-form-group class="col-md-4 p-0">
                        <label for id="enter-new-pin">Enter new PIN</label>
                        <input
                          type="password"
                          autocomplete="off"
                          id="newPin"
                          class="form-control"
                          maxlength="4"
                          v-model="$v.form.newPin.$model"
                          autofocus
                        />
                        <div class="error" v-if="!$v.form.newPin.minLength">
                          Password must have at least
                          {{ $v.form.newPin.$params.minLength.min }} letters.
                        </div>
                      </b-form-group>
                      <b-form-group class="col-md-4 p-0 mt-3">
                        <label for id="renter-pin">Re-enter new PIN</label>
                        <input
                          type="password"
                          autocomplete="off"
                          maxlength="4"
                          class="form-control"
                          id="rePin"
                          v-model="$v.form.rePin.$model"
                        />
                        <div
                          class="error"
                          v-if="
                            !$v.form.rePin.sameAsPassword && form.rePin != ''
                          "
                        >
                          The PINs do not match.
                        </div>
                      </b-form-group>

                      <b-button
                        type="submit"
                        variant="primary"
                        class="mt-4"
                        ref="submitBtn"
                        @click="updatePin()"
                        :disabled="
                          (form.newPin == '' && form.rePin == '') ||
                            form.newPin != form.rePin
                        "
                        id="save-pin"
                      >
                        Save Pin
                      </b-button>
                    </div>
                    <!-- <div class="step2" v-show="isSeen">
                    <h6>You may now set-up your new PIN.</h6>
                    <b-form-group class="col-md-4 p-0">
                      <label for>Enter new PIN</label>
                      <b-form-input type="password" autocomplete="off" v-model="newPin"></b-form-input>
                    </b-form-group>
                    <b-form-group class="col-md-4 p-0">
                      <label for>Re-enter new PIN</label>
                      <b-form-input
                        type="password"
                        @focusout="checkPin()"
                        autocomplete="off"
                        v-model="rePin"
                        ref="search"
                      ></b-form-input>
                      <h6 class="text-danger" v-show="isVisible">The PINs do not match.</h6>
                    </b-form-group>

                      <br />
                      <button
                        type="button"
                        v-b-modal.confirm-password
                        class="btn btn-success grey-btn"
                        ref="submitBtn"
                        :disabled="newPin =='' && rePin==''|| newPin != rePin"
                      >Save PIN</button>
                    </div>-->

                    <div>
                      <b-modal
                        id="confirm-password"
                        ref="confirmPassword"
                        centered
                        hide-header
                        hide-footer
                        size="sm"
                      >
                        <b-form @submit.prevent="savePin">
                          <p class="my-2 pt-1">
                            <img
                              src="../assets/images/success.svg"
                              class="pt-0"
                              alt
                            />&nbsp; PIN updated.
                          </p>
                          <p>
                            You PIN has been changed successfully, you may use
                            it to login next time.
                          </p>
                          <b-button
                            type="submit"
                            class="float-right mt-4"
                            @click="savePin()"
                            id="dismiss-btn-pin"
                          >
                            Dismiss
                          </b-button>
                        </b-form>
                      </b-modal>
                    </div>
                  </form>
                </b-card-text>
              </b-tab>

              <b-tab title="Change Theme">
                <b-card-text>
                  <h5 class="fw-normal">Change Theme</h5>
                  <b-row class="theme-change px-5 py-3">
                    <b-col class="text-center">
                      <img
                        src="../assets/images/Light-theme.png"
                        alt="Light Theme"
                        :class="[
                          state.system.theme == 'theme-light' ? 'active' : '',
                        ]"
                        class="cursor-p"
                        @click="onChangeEventHandler"
                      />
                      <h5
                        class="fw-normal mt-3 fs-14"
                        :class="[
                          state.system.theme == 'theme-light'
                            ? 'active-light'
                            : '',
                        ]"
                      >
                        Light Theme
                        <span v-if="state.system.theme == 'theme-light'"
                          >(Active)</span
                        >
                      </h5>
                    </b-col>
                    <b-col class="text-center">
                      <img
                        src="../assets/images/Dark-theme.png"
                        alt="Dark Theme"
                        :class="[
                          state.system.theme == 'theme-dark' ? 'active' : '',
                        ]"
                        @click="onChangeEventHandler"
                        class="cursor-p"
                      />
                      <h5
                        class="fw-normal mt-3 fs-14"
                        :class="[
                          state.system.theme == 'theme-dark'
                            ? 'active-dark'
                            : '',
                        ]"
                      >
                        Dark Theme
                        <span v-if="state.system.theme == 'theme-dark'"
                          >(Active)</span
                        >
                      </h5>
                    </b-col>
                  </b-row>
                  <!-- <b-row class="align-item-center mt-4 mb-4 justify-content-center">
                    <h6 class="fw-normal pt-1">Light</h6>
                    <toggle-button
                      :width="50"
                      @change="onChangeEventHandler"
                      :labels="false"
                      :value="posTheme"
                    />
                    <h6 class="fw-normal pt-1">&nbsp; Dark</h6>
                  </b-row> -->
                </b-card-text>
              </b-tab>

              <b-tab title="Setup Printer">
                <h5 class="fw-normal">Setup Printer</h5>
                <br />
                <!-- <b-card-text> -->
                <printer />
                <!-- </b-card-text> -->
              </b-tab>

              <b-tab title="Payment Device">
                <b-card-text>
                  <h5 class="fw-normal mb-4">Set Up Payment Device</h5>
                  <form @submit.prevent="setUpPaymentDevice">
                    <b-form-row>
                      <b-form-group class="col-md-4">
                        <label for id="label-serial-number"
                          >Serial Number</label
                        >
                        <b-form-input
                          type="number"
                          autocomplete="off"
                          placeholder="Enter Payment Device Serial Number"
                          :value="
                            state.system.paymentDeviceDetails.serial_number
                          "
                          id="input-serial-number"
                          v-if="state.system.paymentDeviceDetails != ''"
                          :disabled="state.system.isOffline"
                        ></b-form-input>
                        <b-form-input
                          v-if="state.system.paymentDeviceDetails == ''"
                          type="number"
                          id="input-serial-number-add"
                          autocomplete="off"
                          :disabled="state.system.isOffline"
                          placeholder="Enter Payment Device Serial Number"
                          v-model="payment_device.serial"
                          @keyup="clearError"
                        ></b-form-input>
                        <p class="error" v-if="payment_device.error != ''">
                          &nbsp;{{ payment_device.error }}
                        </p>
                      </b-form-group>
                      <b-form-group class="col-md-4">
                        <label for>&nbsp;</label>
                        <br />
                        <b-button
                          type="submit"
                          v-if="state.system.paymentDeviceDetails == ''"
                          variant="danger"
                          style="width: auto"
                          :disabled="payment_device.serial == ''"
                          id="set-device-btn"
                        >
                          <span v-if="!$loading">Remove Device</span>
                          <b-spinner small v-if="$loading"></b-spinner>
                        </b-button>
                        <b-button
                          type="submit"
                          v-if="state.system.paymentDeviceDetails != ''"
                          class="ml-1"
                          variant="primary"
                          id="remove-device"
                        >
                          <span v-if="!$loading">Set Device</span>
                          <b-spinner small v-if="$loading"></b-spinner>
                        </b-button>
                      </b-form-group>
                    </b-form-row>
                  </form>
                </b-card-text>
              </b-tab>
              <b-tab title="License Information " @click="license()">
                <b-card-text class="license">
                  <h5 class="mb-4">License Information</h5>
                  <b-row>
                    <b-col md="2" class="pr-0">
                      <b-progress
                        :value="licenseDetail.percentage"
                        :max="max"
                        animated
                        class="days-count"
                      ></b-progress>
                      <div class="content">
                        <h6 class="m-0" v-text="licenseDetail.days_left"></h6>
                        <p>days left</p>
                      </div>
                    </b-col>
                    <b-col
                      md="5"
                      class="pl-0 mt-5 warning"
                      v-show="isShow && licenseDetail.warning != ''"
                    >
                      <ul class="d-flex p-0" style="list-style-type: none">
                        <li>
                          <img src="/img/alert.c6bdd774.svg" height="20" alt />
                        </li>
                        <li class="pl-2 text-danger" style="font-size: 14px">
                          Your license is expiring soon. Please contact support
                          to renew your license.
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12" class="mb-3 mt-5">
                      <p>License key</p>
                      <h6 v-text="licenseDetail.licence_no"></h6>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col md="3">
                      <p>License activation date</p>
                      <h6 v-text="licenseDetail.purchase_date"></h6>
                    </b-col>
                    <b-col md="3">
                      <p>License expiry</p>
                      <h6 v-text="licenseDetail.expiry_date"></h6>
                    </b-col>
                  </b-row>
                  <b-row class="mb-5">
                    <b-col md="3">
                      <p>Device name</p>
                      <h6 v-text="licenseDetail.name"></h6>
                    </b-col>
                    <b-col md="3">
                      <p>Device address</p>
                      <h6 v-text="licenseDetail.device_address"></h6>
                    </b-col>
                  </b-row>
                  <b-button
                    class="btn btn-danger"
                    @click="revokeLicenseCondition"
                    :disabled="state.system.isOffline || $loading"
                    id="revoke-lic-btn"
                    >Revoke License</b-button
                  >
                  <b-modal
                    ref="revoke"
                    class="remove"
                    size="sm"
                    title="Enter license key"
                    hide-footer
                    centered
                    @hide="isInput = ''"
                  >
                    <p class="mb-3">
                      Please enter your license key below to remove the license
                      from current device.
                    </p>
                    <b-form @submit.prevent="revoke()">
                      <input
                        type="text"
                        id="enter-lic"
                        placeholder="0000 0000 0000"
                        maxlength="12"
                        autofocus
                        v-model="isInput"
                        @keyup="inValid = false"
                        class="form-control mb-3"
                        :disabled="$loading"
                        autocomplete="off"
                      />
                      <p v-show="inValid" class="text-danger pt-2">
                        Invalid Licence No.
                      </p>
                      <b-button
                        class="w-60 btn btn-danger mt-3 float-right"
                        @click="revoke()"
                        :disabled="isInput.length != 12 || $loading"
                        id="revoke-lic-confirm"
                      >
                        <span v-if="$loading == false">Revoke license</span>
                        <b-spinner small v-if="$loading == true"></b-spinner>
                      </b-button>
                    </b-form>
                  </b-modal>
                  <b-modal
                    ref="sync-data"
                    hide-footer
                    hide-header
                    centered
                    no-close-on-backdrop
                    no-close-on-esc
                    size="sm"
                  >
                    <div class="text-center">
                      <h6>Attention!</h6>
                      <p>
                        Unsynced data found Please sync data before revoking
                        license.
                      </p>
                      <b-button @click="openSyncTab" id="open-sync-tab"
                        >Continue</b-button
                      >
                    </div>
                  </b-modal>
                </b-card-text>
              </b-tab>

              <b-tab title="Quick Actions">
                <b-card-text>
                  <h5 class="mb-4">Quick Actions</h5>
                  <p class="mt-2">
                    Find all your important tasks and activities here.
                  </p>

                  <div class="p-3 quick-actions mt-4">
                    <b-card no-body>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item
                          @click="getSettings(), getStateList()"
                          id="get-settings"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                          :class="state.system.isOffline ? 'disabled' : null"
                        >
                          <h5 class="mb-0">Get new settings</h5>
                          <span>
                            Last updated :
                            {{ state.system.last_setting_invoked }}
                          </span>
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item
                          @click="printSlip()"
                          id="reprint-settlement-slip"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                        >
                          <h5 class="mb-0">Reprint settlement slip</h5>
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item
                          id="keyboard-shortcuts"
                          @click="openKeyboardModal"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                        >
                          <h5 class="mb-0">Keyboard shortcuts</h5>
                          <keyboard-shortcut-modal
                            :openShortcuts="openShortcuts"
                            @hide="hideKeyboardModal"
                          ></keyboard-shortcut-modal>
                          <!-- <span>Last updated {{ state.last_setting_invoked}}</span> -->
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item
                          @click="openPortList"
                          id="set-weighing-scale"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                        >
                          <h5 class="mb-0">
                            <span v-if="state.system.weightPort == ''"
                              >Setup</span
                            >
                            weighing scale
                          </h5>
                          <span v-if="state.system.weightPort != ''">
                            <b-button
                              type="button"
                              variant="danger"
                              style="padding: 2px 10px"
                            >
                              {{ state.system.weightPort }}
                            </b-button>
                          </span>
                          <b-modal
                            id="weighing-scale-modal"
                            size="sm"
                            hide-footer
                            centered
                            title="Available Port(s)"
                          >
                            <div
                              class="d-flex align-items-center justify-content-center"
                              v-if="portList.length == 0"
                            >
                              <p class="mb-0 mt-3">No port found</p>
                            </div>
                            <table
                              class="table table-borderless table-hovered mt-2"
                            >
                              <!-- <tr>
                                <th
                                  colspan="2"
                                  class="text-center"
                                  style="background-color: #6699cc;"
                                >
                                  <h6 style="margin:0; font-weight:300; color: #fff;">Port List</h6>
                                </th>
                              </tr>-->
                              <tr v-for="port in portList" :key="port">
                                <td
                                  style="vertical-align: middle"
                                  class="p-0 pb-3"
                                >
                                  <p class="mb-0">{{ port }}</p>
                                </td>
                                <td class="text-right p-0 pb-3">
                                  <b-button
                                    class="btn-port"
                                    type="button"
                                    :id="port"
                                    @click="setPort(port)"
                                  >
                                    {{ readData }}
                                  </b-button>
                                </td>
                              </tr>
                            </table>
                          </b-modal>
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-2">
                        <b-row class="p-0"
                          ><b-col
                            :md="state.system.plu_data.status ? '10' : '12'"
                            :class="
                              state.system.plu_data.status ? 'pr-0' : null
                            "
                          >
                            <b-list-group-item
                              class="d-flex align-items-center justify-content-between pt-4 pb-4"
                              id="set-weighing-scale-plu"
                              @click="pluConfigModal = true"
                            >
                              <h5 class="mb-0 w-100">
                                <span>Setup weighing scale (PLU Code)</span>
                              </h5>
                            </b-list-group-item>
                            <plu-config-modal
                              :open="pluConfigModal"
                              @plu-config-close="pluConfigModal = false"
                            />
                          </b-col>
                          <b-col md="2" v-if="state.system.plu_data.status">
                            <b-list-group-item
                              class="d-flex align-items-center justify-content-center pt-4 pb-4"
                              @click="$store.commit('system/clearPluData')"
                            >
                              <h5
                                class="mb-0"
                                style="color: #ff6666; font-weight: 600"
                              >
                                Clear
                              </h5>
                            </b-list-group-item>
                          </b-col>
                        </b-row>
                      </b-list-group>
                      <b-list-group flush class="mb-2" v-if="mp200Status">
                        <b-list-group-item
                          @click="openPortListPayment"
                          id="set-ezswypee-mp200"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                        >
                          <h5 class="mb-0">
                            <span v-if="state.system.mp200Port == ''"
                              >Setup</span
                            >
                            EzSwype MP200
                          </h5>
                          <span v-if="state.system.mp200Port != ''">
                            <b-button
                              variant="success"
                              style="padding: 2px 10px"
                            >
                              {{ state.system.mp200Port }}
                            </b-button>
                          </span>

                          <b-modal
                            id="mp200-modal"
                            size="sm"
                            hide-footer
                            title="Available Port(s)"
                            centered
                          >
                            <div
                              class="d-flex align-items-center justify-content-center"
                              v-if="portList.length == 0"
                            >
                              <p class="mb-0 mt-3">No port found</p>
                            </div>
                            <table
                              class="table table-borderless table-hovered mt-2"
                            >
                              <!-- <tr>
                                <th
                                  colspan="2"
                                  class="text-center"
                                  style="background-color: #6699cc;"
                                >
                                  <h6 style="margin:0; font-weight:300; color: #fff;">Port List</h6>
                                </th>
                              </tr>-->
                              <tr v-for="port in portList" :key="port">
                                <td
                                  style="vertical-align: middle"
                                  class="p-0 pb-3"
                                >
                                  <p class="mb-0">{{ port }}</p>
                                </td>
                                <td class="text-right p-0 pb-3">
                                  <b-button
                                    class="btn-port"
                                    type="button"
                                    @click="setPortForPaymement(port)"
                                    :id="port"
                                  >
                                    {{ readData }}
                                  </b-button>
                                </td>
                              </tr>
                            </table>
                          </b-modal>
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item
                          id="toggle-scan-mode"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4 cursor-default"
                        >
                          <h5
                            class="mb-0"
                            v-text="
                              `Scan only mode ${
                                state.system.scan_only_mode ? 'ON' : 'OFF'
                              }`
                            "
                          />
                          <toggle-button
                            :width="45"
                            :labels="false"
                            :value="state.system.scan_only_mode"
                            color="#4da5e6"
                            :sync="true"
                            class="my-auto"
                            @change="toggleScanMode"
                          />
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group
                        flush
                        v-if="!state.system.isOffline"
                        class="mb-2"
                      >
                        <b-list-group-item
                          id="toggle-search"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4 cursor-default"
                        >
                          <h5 class="mb-0">
                            Switch search to offline
                          </h5>
                          <toggle-button
                            :width="45"
                            :labels="false"
                            :value="
                              state.system.product_search_is_offline == 1
                                ? true
                                : false
                            "
                            color="#4da5e6"
                            :sync="true"
                            class="my-auto"
                            @change="switchSearch"
                          />
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-4">
                        <b-list-group-item
                          id="toggle-search"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4 cursor-default"
                        >
                          <h5 class="mb-0">
                            Enable auto printing mode
                          </h5>
                          <toggle-button
                            :width="45"
                            :labels="false"
                            :value="state.billing.auto_print_enable"
                            color="#4da5e6"
                            :sync="true"
                            class="my-auto"
                            @change="printHandler"
                          />
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush>
                        <b-list-group-item
                          @click="switchToOnline"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                          v-if="checkOfflineState"
                          id="switch-pos-to-online"
                        >
                          <h5 class="mb-0">Switch to Online</h5>
                        </b-list-group-item>
                      </b-list-group>
                      <!-- <b-list-group flush>
                        <b-list-group-item
                          @click="getUdidFunc"
                          class="d-flex align-items-center justify-content-between pt-4 pb-4"
                        >
                          <h5 class="mb-0">
                            Get Device Info
                          </h5>
                        </b-list-group-item>
                        <b-modal
                          ref="device-info"
                          centered
                          hide-footer
                          title="Device Info"
                          size="sm"
                        >
                          <p>UDID: <span v-text="getUdid"></span></p>
                          <p>
                            v_id:
                            <span v-text="state.sessions.user.v_id"></span>
                          </p>
                          <p>
                            vu_id:
                            <span v-text="state.sessions.user.vu_id"></span>
                          </p>
                          <p>
                            terminal_id:
                            <span
                              v-text="state.system.settings.terminal_id"
                            ></span>
                          </p>
                        </b-modal>
                      </b-list-group> -->
                    </b-card>
                  </div>
                </b-card-text>
              </b-tab>

              <b-tab
                title="Sync Data"
                v-if="
                  offline.storageSummry != '' &&
                    state.system.settings.vendor_app_menu.hasOwnProperty(
                      'offline'
                    ) &&
                    state.system.settings.vendor_app_menu.offline.status == 1 &&
                    state.system.isOffline == false
                "
              >
                <b-card-text>
                  <h5 class="mb-4">Sync Data</h5>
                  <b-row>
                    <b-col>
                      Fetch data from the cloud and store it locally for use in
                      offline mode.
                    </b-col>
                  </b-row>
                  <b-row class="mt-3 storage">
                    <b-col class="usage" md="3">
                      <p class="mt-2">
                        <i class="dot"></i>Storage used
                        <br />
                        <span class="pl-4">
                          {{ bytesToSize(offline.storageSummry.usage) }}
                        </span>
                      </p>
                    </b-col>
                    <b-col md="3">
                      <p class="mt-2">
                        <i class="dot"></i>Storage available
                        <br />
                        <span class="pl-4">
                          {{ bytesToSize(offline.storageSummry.quota) }}
                        </span>
                      </p>
                    </b-col>
                    <b-col md="12" class="mt-3">
                      <b-progress
                        :value="
                          dataUsage(
                            offline.storageSummry.usage,
                            offline.storageSummry.quota
                          )
                        "
                        animated
                        show-progress
                        id="demo"
                      ></b-progress>
                    </b-col>
                  </b-row>

                  <div class="p-3 quick-actions mt-4">
                    <!-- <b-card no-body>
                      <b-list-group flush class="mb-3">
                        <a @click="syncTable(index)">
                        <b-list-group-item
                          v-for="(table, index) in state.offline.syncTables"
                          :key="index"
                          class="p-0 mb-3"
                        >
                           <div class="d-flex  align-items-center justify-content-between px-3 py-3">
                            <h5 class="mb-0" v-text="table.name"></h5>
                            <p v-show="isLoad" class="text-success m-0">Syncing</p>
                           <p v-if="isLoad != true" class="m-0">Last synced {{ table.date }}</p>
                          </div>
                        
                          <div class="clearfix"></div>
                            <div class="w-100" v-show="isLoad" > 
                              <b-progress :value="100" variant="info" striped animated></b-progress>
                            </div>
                        </b-list-group-item>
                       
                        </a>
                      </b-list-group>
                       <b-modal
                        ref="synced-modal"
                        id="synced-modal"
                        size="sm"
                        hide-footer
                        hide-header
                        centered
                      >
                        <p class="text-center">Syncing</p>
                        <b-progress :value="100" variant="info" striped animated class="mt-3"></b-progress>
                      </b-modal>
                    </b-card>-->
                    <b-card no-body>
                      <p>Sync inbound (Download)</p>
                      <b-list-group
                        flush
                        class="mb-2"
                        v-for="(table, index) in state.offline.syncTables"
                        :key="index"
                      >
                        <b-list-group-item class="p-0">
                          <div
                            @click="syncTable(index)"
                            class="d-flex align-items-center justify-content-between px-3 py-4"
                            style="cursor: pointer"
                          >
                            <h5 class="mb-0" v-text="table.name"></h5>
                            <p
                              class="text-success m-0"
                              v-show="isLoad && isIndex == index"
                            >
                              Syncing
                            </p>
                            <p
                              v-show="isLoad == false"
                              class="m-0"
                              v-if="table.date != ''"
                            >
                              Last Synced on {{ table.date }}
                            </p>
                            <p
                              v-show="isLoad == true && isIndex != index"
                              class="m-0"
                              v-if="table.date != ''"
                            >
                              Last Synced on {{ table.date }}
                            </p>
                          </div>
                          <div v-show="isLoad && isIndex == index">
                            <b-progress
                              :value="100"
                              height="4px"
                              variant="primary"
                              striped
                              animated
                            ></b-progress>
                          </div>
                          <!-- <h5 class="mb-0" v-text="table.name"></h5> -->
                          <!-- <a @click="syncTable(index)" class="btn btn-danger" title="sync">
                            <font-awesome-icon :icon="['fas', 'redo']" />
                          </a>-->
                        </b-list-group-item>
                      </b-list-group>
                      <p class="mt-2">Sync outbound (Upload)</p>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item
                          class="p-0"
                          :disabled="out_sync_invoice_count == 0"
                        >
                          <div
                            @click="outboundsync"
                            class="d-flex align-items-center justify-content-between px-3 py-4"
                            style="cursor: pointer"
                          >
                            <h5 class="mb-0">
                              Sync Offline Invoices ({{
                                out_sync_invoice_count
                              }})
                            </h5>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                      <b-list-group flush class="mb-2">
                        <b-list-group-item class="p-0">
                          <div
                            @click="outboundSessionSync"
                            class="d-flex align-items-center justify-content-between px-3 py-4"
                            style="cursor: pointer"
                          >
                            <h5 class="mb-0">Sync Offline Session</h5>
                          </div>
                        </b-list-group-item>
                      </b-list-group>
                      <!-- <b-modal
                        ref="synced-modal"
                        id="synced-modal"
                        size="sm"
                        hide-footer
                        hide-header
                        centered
                      >
                        <p class="text-center">Syncing</p>
                        <b-progress :value="100" variant="info" striped animated class="mt-3"></b-progress>
                      </b-modal>-->
                    </b-card>
                  </div>
                </b-card-text>
                <b-modal
                  ref="outbound-progress"
                  hide-footer
                  hide-header
                  centered
                  @hide="clearValues"
                  no-close-on-backdrop
                  no-close-on-esc
                  size="md"
                >
                  <div class="d-block">
                    <b-row class="mt-2">
                      <b-col md="6">
                        <h6 style="font-weight: normal">
                          <span>
                            <font-awesome-icon :icon="['fas', 'upload']" />
                          </span>
                          Syncing Invoices
                        </h6>
                      </b-col>
                      <b-col md="6" class="text-success text-right">
                        {{
                          Math.ceil(
                            (out_sync_invoice_done / out_sync_invoice_count) *
                              100
                          )
                        }}% Complete
                      </b-col>
                    </b-row>
                    <b-row class="mt-4">
                      <b-col md="12">
                        <span v-if="sync_status.message != 'Sync completed!'">
                          Uploading Invoices {{ out_sync_invoice_done }}/{{
                            out_sync_invoice_count
                          }}
                        </span>
                        <span v-if="sync_status.message == 'Sync completed!'"
                          >Invoices Uploaded: {{ out_sync_invoice_done }}</span
                        >
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col v-if="sync_status.message != 'Sync completed!'">
                        {{ invoice_no }}
                      </b-col>
                    </b-row>
                    <b-row class="mt-2">
                      <b-col md="12">
                        <b-progress
                          :value="100"
                          :max="100"
                          v-if="out_sync_invoice_done == 0 && $loading == true"
                          animated
                        ></b-progress>
                        <b-progress
                          v-if="out_sync_invoice_done != 0"
                          :value="out_sync_invoice_done"
                          :max="out_sync_invoice_count"
                          show-progress
                          variant="success"
                        ></b-progress>
                      </b-col>
                    </b-row>
                    <p :class="sync_status.class">{{ sync_status.message }}</p>
                    <b-row class="mt-3">
                      <b-col md="12" class="text-right">
                        <!-- <b-button
                            v-if="show_start == true"
                            variant="success"
                            :disabled="out_sync_invoice_count == 0 || state.system.isOffline == true"
                            @click="outboundsync"
                        >Start</b-button>-->
                        <b-button
                          v-if="$loading == false"
                          class="ml-1"
                          variant="danger"
                          id="close-sync-modal"
                          @click="closeOutSync"
                          >Close</b-button
                        >
                      </b-col>
                    </b-row>
                  </div>
                </b-modal>
              </b-tab>

              <b-tab title="Relase Notes" v-if="false">
                <h5 class="fw-normal">Release Notes Version 1.0.0</h5>
                <hr />
                <!-- <b-card-text> -->
                <!-- <printer></printer> -->
                <release-notes />
                <!-- </b-card-text> -->
              </b-tab>

              <!-- <b-tab title="Sync Outbound" v-if="state.system.isOffline == false"> -->
              <!-- <b-tab
                title="Sync Outbound"
                v-if="state.system.settings.vendor_app_menu.offline.status == 1"
              >-->
            </b-tabs>
          </b-card>
        </b-container>
      </section>
    </template>
    <!-- <b-modal id="log_out" size="sm" hide-footer hide-header centered>
      <ul>
        <li>
          <img src="../assets/images/Logout.svg" class="text-center" alt />
        </li>
        <li>
          <p class="mb-4" v-text="logoutMsg"></p>
        </li>
      </ul>
      <b-button
        variant="danger"
        class="float-right px-4"
        @click="logout"
        id="logout-confirm"
      >
        <span v-if="$loading == false">Logout</span>
        <b-spinner small v-if="$loading == true"></b-spinner>
      </b-button>
      <b-button
        class="float-left px-4"
        @click="$bvModal.hide('log_out')"
        id="logout-cancel"
      >
        Cancel
      </b-button>
    </b-modal> -->
  </dashboard>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { validationMixin } from "vuelidate";
import Printer from "../components/Printer";
import KeyboardShortcutModal from "../components/KeyboardShortcutModal";
import ReleaseNotes from "../components/ReleaseNotes";
import * as helper from "../helper";

import {
  required,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import Dashboard from "../views/Dashboard";
import axios from "axios";
import { mapState } from "vuex";
import * as msg from "../message";
import qz from "../printer";
import db from "../database";
// import * as socket from "../socket";
import PluConfigModal from "../components/PluConfigModal";

export default {
  name: "settings",
  props: ["id"],
  mixins: [validationMixin],
  components: {
    Dashboard,
    Datepicker,
    Printer,
    KeyboardShortcutModal,
    ReleaseNotes,
    PluConfigModal,
  },
  data() {
    return {
      Title: "Settings",
      searchableName: true,
      isBusy: false,
      valUsage: 80,
      isVisible: false,
      isSeen: false,
      isHide: false,
      max: 100,
      isLoad: false,
      isIndex: "",
      info: "",
      isInput: "",
      isIncorrect: false,
      inValid: false,
      currentPin: "",
      maxPinLength: 4,
      isShow: false,
      logoutMsg: "",
      licenseDetail: "",
      revokeDetail: "",
      // max: 100,
      gender: "",
      first_name: "",
      last_name: "",
      dob: "",
      print: true,
      stringHtml: "",
      portList: [],
      readData: "Use This",
      session: {
        type: "",
        openBox: false,
      },
      test: "",
      form: {
        currentPin: "",
        newPin: "",
        rePin: "",
      },
      payment_device: {
        isBtnEnbale: false,
        serial: "",
        error: "",
      },
      openShortcuts: false,
      offline: {
        storageSummry: "",
      },
      out_sync_invoice_count: 0,
      out_sync_invoice_done: 0,
      invoice_no: "",
      // show_close: false,
      // show_start: false,
      sync_status: {},
      currency: "",
      timezone: "",
      tabIndex: 0,
      pluConfigModal: false,
    };
  },
  validations: {
    form: {
      currentPin: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4),
      },
      newPin: {
        required,
        minLength: minLength(4),
      },
      rePin: {
        sameAsPassword: sameAs("newPin"),
      },
    },
  },
  created() {
    this.logoutMsg = msg.LOGOUT_MESSAGE;
    this.isStoragePersisted();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    //   sync() {
    //   navigator.storage.estimate().then(function(estimate) {
    //     document.getElementById("percent").innerHTML =
    //         (offline.storageSummry.usage / offline.storageSummry.quota * 100).toFixed(2);
    //   });
    // },
    posTheme() {
      if (this.state.system.theme == "theme-dark") {
        return true;
      } else {
        return false;
      }
    },
    mp200Status() {
      let data = false;
      this.state.system.settings.payment_type.map((item) => {
        if (item.name == "ezswype") {
          if (item.status == 1) {
            data = true;
          }
        }
      });
      return data;
    },

    changeDate(dob) {
      return this.$moment(dob).format("MMMM Do YYYY");
    },
    checkOfflineState() {
      let check = false;
      if (
        this.state.system.settings.vendor_app_menu.hasOwnProperty("offline") &&
        this.state.system.settings.vendor_app_menu.offline.status == 1 &&
        this.state.system.isOffline == true &&
        window.navigator.onLine
      ) {
        check = true;
      }
      return check;
    },
  },

  mounted() {
    this.$bvModal.show("synced-modal");
    this.fetchUserInfo();
    this.dataUsage();
    this.dispInvoice();
  },

  // watch: {},
  methods: {
    // async getUdidFunc() {
    //   let biri = require("biri");
    //   this.getUdid = await biri();
    //   this.$refs["device-info"].show();
    // },
    switchSearch() {
      let data = 0;
      if (this.state.system.product_search_is_offline == 1) data = 0;
      else if (this.state.system.product_search_is_offline == 0) data = 1;

      this.$store.commit("system/changeSearchMode", data);
    },
    switchToOnline() {
      this.$store.commit("system/setConnected", false);
      this.$store.commit("system/forceOfflineStatus", false);
      helper.verifyOfflineState();
    },
    outboundSessionSync() {
      helper.syncSessionOnline("setting");
    },
    closeOutSync() {
      this.dispInvoice();
      this.$refs["outbound-progress"].hide();
    },
    dispInvoice() {
      let isPresent = 0;
      this.out_sync_invoice_count = 0;
      db.transaction("rw", db.order, async () => {
        await db.order
          .orderBy("id")
          .and((filter) => {
            return filter.status == "success" && filter.sync == 0;
          })
          .each(() => {
            isPresent = 1;
            this.out_sync_invoice_count++;
          });
      }).then(() => {
        if (isPresent == 0) {
          this.out_sync_invoice_count = 0;
        }
      });
    },
    outboundsync() {
      this.$refs["outbound-progress"].show();
      if (this.$loading == false) {
        this.$loading = true;
      }
      let cool = {};
      cool.item_list = [];
      cool.payment_list = [];
      cool.customer = {};
      let customer_id = 0;
      let invoice_no = "";
      let invoice_id = [];
      let order_id = "";
      let remark = "";
      let session_id = 0;
      db.transaction(
        "rw",
        db.invoice,
        db.payment,
        db.order,
        db.customer,
        async () => {
          await db.order
            .orderBy("id")
            .and((filter) => {
              order_id = filter.id;
              return filter.status == "success" && filter.sync == 0;
            })
            .first()
            .then(async (item) => {
              remark = item.bill_remark;
              session_id = item.session_id;
              invoice_id = JSON.parse(item.cart_id);
              invoice_id.map(async (product) => {
                await db.invoice.get(product).then((cart_item) => {
                  invoice_no = cart_item.invoice_no;
                  this.invoice_no = cart_item.invoice_no;
                  customer_id = cart_item.user_id;
                  cool.invoice_no = cart_item.invoice_no;
                  cool.date = cart_item.date;
                  cool.time = cart_item.time;
                  cool.item_list.push(cart_item);
                });
              });
            });
        }
      )
        .then(async () => {
          await db.payment
            .where("invoice_id")
            .equals(invoice_no)
            .each((payment) => {
              cool.payment_list.push(payment);
            });
        })
        .then(async () => {
          await db.customer
            .where("id")
            .equals(customer_id)
            .each((customer) => {
              cool.customer = customer;
            });
        })
        .then(() => {
          let data = {
            transaction_type: "sales",
            transaction_sub_type: "sales",
            customer: JSON.stringify(cool.customer),
            item_list: JSON.stringify(cool.item_list),
            payment_list: JSON.stringify(cool.payment_list),
            invoice_no: invoice_no,
            date: cool.date,
            time: cool.time,
            remark: remark,
            session_id: session_id,
            url: "/vendor/out-bound-table-sync",
          };
          let stringCool = JSON.stringify(data);
          var blob = new Blob([stringCool], { type: "text/plain" });
          console.log(data.invoice_no);
          var fd = new FormData();
          fd.append("type", "invoice");
          fd.append("api_token", this.state.sessions.user.api_token);
          fd.append("vu_id", this.state.sessions.user.vu_id);
          fd.append("v_id", this.state.sessions.user.v_id);
          fd.append("store_id", this.state.sessions.user.store_id);
          fd.append("trans_from", this.state.system.trans_from);
          fd.append("udidtoken", this.state.system.licence);
          fd.append("terminal_id", this.state.system.settings.terminal_id);
          fd.append("invoice_data", blob, "rajat");
          axios
            .post(data.url, fd)
            .then(async (response) => {
              if (response.status == 200) {
                invoice_id.map(async (product) => {
                  await db.invoice.update(product, { sync: 1 });
                });
                await db.order.update(order_id, { sync: 1 });
                // await db.customer.update(customer_id, { sync: 1 });
                console.log("done");
                let logsData = {
                  date: new Date(),
                  description:
                    "Invoice_no: " + invoice_no + " Synced Successfully!",
                  status: "Success",
                  source: "Outbound Sync",
                };
                db.logs.put(logsData);
                this.out_sync_invoice_done += 1;
                if (this.out_sync_invoice_count == this.out_sync_invoice_done) {
                  this.$loading = false;
                  this.sync_status = {
                    message: "Sync completed!",
                    class: "text-success",
                  };
                } else {
                  this.outboundsync();
                }
              } else {
                this.$loading = false;
                let logsData = {
                  date: new Date(),
                  description: "Invoice_no: " + invoice_no + " not synced!",
                  status: "Fail",
                  source: "Outbound Sync",
                };
                db.logs.put(logsData);
                this.sync_status = {
                  message: "Sync not completed! Try Again.",
                  class: "text-danger",
                };
              }
            })
            .catch(() => {
              this.$loading = false;
              let logsData = {
                date: new Date(),
                description: "Invoice_no: " + invoice_no + " not synced!",
                status: "Fail",
                source: "Outbound Sync",
              };
              db.logs.put(logsData);
              this.sync_status = {
                message: "Sync not completed! Try Again.",
                class: "text-danger",
              };
            });
        });
    },
    clearValues() {
      this.out_sync_invoice_done = 0;
      this.sync_status = {};
    },
    //changeDate() {
    // return this.$moment(dob).format("MMMM Do YYYY");
    // },
    // key(){

    // },
    getSettings() {
      this.$loading = true;
      let country_details = {
        phone_digit: 10,
        dial_code: "+91",
        country_id: 101,
      };
      this.$store
        .dispatch("system/getLatestSettings")
        .then(() => {
          if (
            this.state.system.settings.vendor_login_details.hasOwnProperty(
              "country_details"
            )
          ) {
            country_details = this.state.system.settings.vendor_login_details
              .country_details;
          }
          this.$store.commit("system/getCountryDetails", country_details);
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
      this.state.system.last_setting_invoked = this.$moment().format(
        "MMMM Do YYYY, h:mm:ss a"
      );
    },
    dataUsage(usage, quota) {
      let a = parseInt(Math.floor(Math.log(usage) / Math.log(1024)));
      let b = parseInt(Math.floor(Math.log(quota) / Math.log(1024)));
      let c = Math.round(usage / Math.pow(1024, a));
      let d = Math.round(quota / Math.pow(1024, b));
      let e = d * 1024;
      let f = (c / e) * 100;
      // console.log(f);
      return f;
    },
    printSlip() {
      this.$loading = true;
      if (typeof Android !== "undefined" && Android !== null) {
        let sessionData = {
          v_id: this.state.sessions.user.v_id,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          settlement_session_id: this.state.system.settings.settlement
            .settlement_session_id,
          // settlement_session_id: "",
          trans_from: this.state.system.trans_from,
          api_token: this.state.sessions.user.api_token,
          manufacturer_name: this.state.system.device_name,
          terminal_id: this.state.system.settings.terminal_id,
          url: "vendor/print-settlement",
        };
        // let data = Object.assign(invoiceData, this.customerData);
        axios.post(sessionData.url, sessionData).then((res) => {
          // console.log(res.data.print_data);
          if (res.data.status == "fail") {
            let alertData = {
              message: res.data.message,
              type: "danger",
            };
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
          } else {
            let postData = {
              type: "print_settlement",
              data: res.data.print_data,
            };
            returnValue(postData);
          }
          this.print = false;
        });
        // console.log(data);
      } else {
        let manuName = "";
        if (this.state.system.printer != "") {
          manuName = this.state.system.printer;
        }
        let postData = {
          v_id: this.state.sessions.user.v_id,
          store_id: this.state.sessions.user.store_id,
          vu_id: this.state.sessions.user.vu_id,
          settlement_session_id: this.state.system.settings.settlement
            .settlement_session_id,
          // settlement_session_id: "",
          trans_from: this.state.system.trans_from,
          api_token: this.state.sessions.user.api_token,
          manufacturer_name: manuName,
          terminal_id: this.state.system.settings.terminal_id,
          url: "vendor/print-settlement",
        };
        axios
          .post(postData.url, postData)
          .then((res) => {
            if (res.data.status == "fail") {
              let alertData = {
                message: res.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
            } else {
              this.$loading = false;
              if (this.state.system.printer != "" && qz.websocket.isActive()) {
                this.stringHtml = res.data.print_data
                  .replace(
                    /<size=24>|<bold>|<\/bold>|<\/size>|<normal>|<\/normal>/gi,
                    ""
                  )
                  .replace(/<center>/gi, "<div class='cool-center'>")
                  .replace(/<left>/gi, "<div class='cool-left'>")
                  .replace(/<right>/gi, "<div class='cool-right'>")
                  .replace(/<text>/gi, "<span>")
                  .replace(/<\/text>/gi, "</span>")
                  .replace(/<\/center>|<\/left>|<\/right>/gi, "</div>");
                this.stringHtml =
                  "<div class='webpos-print'>" + this.stringHtml + "</div>";
                setTimeout(() => {
                  this.printHtml();
                }, 1000);
                // this.printHtml(res.data.html_data);
              } else {
                this.$store.commit(
                  "saveLastSessionPrintData",
                  res.data.html_data
                );
              }
            }
            this.$loading = false;
            this.print = false;
          })
          .catch(() => {
            this.$loading = false;
          });
      }
    },
    printHtml() {
      // this.$nextTick(() => {
      let billData = [];
      let data = document.querySelectorAll(".webpos-print");
      //console.log(data);
      for (var i = 0; i < data.length; i++) {
        let tempData = data[i].childNodes;
        for (var j = 0; j < tempData.length; j++) {
          billData.push({
            content: tempData[j].textContent,
            size: tempData[j].textContent.length,
          });
        }
      }
      let htmlData = "";
      htmlData = Object.keys(billData)
        .map(function(k) {
          let convert = "";
          if (billData[k].size == 1) {
            convert = billData[k].content;
            convert = convert.toString();
          } else {
            convert = billData[k].content.substr(
              0,
              billData[k].content.length - 1
            );
            convert = convert + "\x0A";
            convert = convert.toString();
          }
          return convert;
        })
        .join("");
      // console.log(htmlData.toString());

      let config = qz.configs.create(this.state.system.printer, {
        units: "mm",
      });
      let centerAlign = "\x1B" + "\x61" + "\x31";
      let paperCut = "\x1D" + "\x56" + "\x30";
      let lineBreak = "\x0A" + "\x0A" + "\x0A";
      let pdata = [centerAlign + htmlData + lineBreak + paperCut];
      qz.print(config, pdata);
      // let self = this;
      // let printerConfig = {
      //   colorType: "blackwhite",
      //   copies: 1,
      //   margins: "0",
      //   rasterize: "false",
      //   rotation: "0",
      //   scaleContent: "false",
      //   units: "mm"
      // };
      // let config = qz.configs.create(this.state.system.printer, printerConfig);
      // let options = {
      //   language: "ESCP"
      // };
      // let size = 11;
      // // Paper width 8 cm
      // let defaultStyle =
      //   "<style>* { font-size: 10px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table {width:280px;  margin-left: -70px; margin-right:0px;  } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; margin-left:-10px } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:0px !important; } tbody { display: table !important; }</style>";
      // if (this.printSize == 58) {
      //   // Paper width 5 cm
      //   size = 10;
      //   defaultStyle =
      //     "<style>* { font-size: 8px; font-weight: bold; white-space: pre-wrap; margin:0; padding:0; } table { width:200px;  margin-left:-80px; margin-right:5px } pre { white-space: pre-wrap; word-wrap: break-word;  } .center { text-align: center; } .left { text-align: left; } .right { text-align: right; } .left pre { padding-left:0px !important; } .right pre { padding-left:15px !important; } tbody { display: table !important; width: inherit; word-wrap: break-word; }</style>";
      // }
      // let data = [
      //   {
      //     type: "raw",
      //     format: "html",
      //     flavor: "plain", // or 'plain' if the data is raw HTML
      //     // data: this.state.billing.invoice.data.html_data,
      //     data: "<html><body>" + defaultStyle + html + "</body></html>"
      //     // data:
      //     //   '<html><body><style>* { font-size: 10px; white-space: pre-wrap; }</style><table style="border:1px solid black"><tr><td style="font-size:13px"><b><pre>Pos Store -1\n</pre></b></td></tr><tr><t d style="font-size:12px"><span><pre>D-3 Phase-II Opp Lajpat Nagar Police Station Cool School\n</pre></span></t></tr></table></body></html>'
      //   }
      // ];
      // // console.log(config);
      // qz.print(config, data)
      //   .then(function() {
      //     console.log("Sent data to printer");
      //   })
      //   .catch(function(e) {
      //     console.error(e);
      //   });
    },

    customFormatter(date) {
      return this.$moment(date).format("MMMM Do YYYY");
    },
    // logout() {
    //   this.$loading = true;
    //   this.$store.dispatch("sessions/logout").then(() => {
    //     this.$router.push("/");
    //     // location.reload();
    //   });
    // },
    revoke_lic() {
      this.$loading = true;
      this.$store.dispatch("sessions/logout").then(() => {
        this.$router.push("/register");
        this.$store.commit("clearState");
        this.$store.commit("clearOnRevokeLic");
        helper.clearAllStores();
        // location.reload();
      });
    },
    updateDetails() {
      this.$loading = true;
      let data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        mobile: this.state.sessions.user.mobile,
        first_name: this.first_name,
        last_name: this.last_name,
        gender: this.gender,
        email: this.state.sessions.user.email,
        terminal_id: this.state.system.settings.terminal_id,
        dob: this.$moment(this.dob).format("MMMM Do YYYY"),
        url: "/vendor/profile-update",
      };
      axios
        .post(data.url, data)
        .then((res) => {
          let data = {
            mobile: this.state.sessions.user.mobile,
            email: this.state.sessions.user.email,
            first_name: this.first_name,
            last_name: this.last_name,
            dob: this.dob,
            gender: this.gender,
            terminal_id: this.state.system.settings.terminal_id,
          };
          this.$loading = false;
          // console.log(this.$store);
          this.$store.commit("sessions/updateProfile", data);
          let alertData = {
            message: res.data.message,
            type: "success",
          };
          this.$showAlert = true;
          this.$store.commit("notifications/showAlert", alertData);
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    license: function() {
      this.$loading = true;
      let data = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        // udidtoken: this.state.trans_from,
        vu_id: this.state.sessions.user.vu_id,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/device-licence-detail",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          this.licenseDetail = response.data.data;
          this.$loading = false;
          if (this.licenseDetail.warning != "") {
            this.isShow = true;
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    revoke() {
      this.$loading = true;
      let data = {
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        // udidtoken: this.state.trans_from,
        licence: this.isInput,
        vu_id: this.state.sessions.user.vu_id,
        terminal_id: this.state.system.settings.terminal_id,
        url: "/revoke-licence?",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          this.revokeDetail = response.data;
          if (this.revokeDetail.status == "success") {
            this.$refs["revoke"].hide();
            this.licenseDetail = "";
            // this.logout = this.$router.push("/");
            this.revoke_lic();
          }
          this.licenseDetail;
          this.inValid = true;
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    viewPassword() {
      let password = document.querySelector(".LoginInput");
      if (password.type == "password") {
        password.type = "text";
        this.isVisible = true;
        this.isHide = true;
      } else {
        password.type = "password";
        this.isVisible = false;
        this.isHide = false;
      }
    },
    savePin() {
      this.$loading = false;
      this.$refs["confirmPassword"].hide();
      this.form.currentPin = "";
      this.isIncorrect = false;
      this.$store.dispatch("sessions/logout").then(() => {
        this.$router.push("/");
      });
    },
    checkPin() {
      this.$loading = true;
      //console.log('Continue is clicked another');
      let data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        mobile: this.state.sessions.user.mobile,
        terminal_id: this.state.system.settings.terminal_id,
        pin: this.form.currentPin,
        url: "/vendor/verify-password",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          if (response.data.status == "pin_verified") {
            this.isSeen = !this.isSeen;
            this.isIncorrect = false;
          }
          //fetchUserInfo = data;
          this.isIncorrect = true;
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });

      // if (this.newPin != this.rePin) {
      //   this.isVisible = true;
      // } else {
      //   this.isVisible = false;
      // }
    },
    updatePin() {
      this.$loading = true;
      this.isIncorrect = false;
      let data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        mobile: this.state.sessions.user.mobile,
        terminal_id: this.state.system.settings.terminal_id,
        pin: this.form.newPin,
        url: "/vendor/setup-pin",
      };
      axios
        .post(data.url, data)
        .then((response) => {
          if (response.data.status == "success") {
            this.$refs.confirmPassword.show();
            this.isSeen = !this.isSeen;
            this.form.newPin = "";
            this.form.rePin = "";
          }
          //fetchUserInfo = data;
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    onChangeEventHandler() {
      let bodyClass = document.querySelector("body");
      if (this.state.system.theme == "theme-dark") {
        this.$store.dispatch("system/changeTheme", "theme-light");
        bodyClass.classList.remove("theme-dark");
        bodyClass.classList.add("theme-light");
      } else {
        this.$store.dispatch("system/changeTheme", "theme-dark");
        bodyClass.classList.remove("theme-light");
        bodyClass.classList.add("theme-dark");
      }
    },
    // onChangeEventHandler(data) {
    //   this.$emit("status", data.value);
    //   let bodyClass = document.querySelector("body");
    //   if (data.value == false) {
    //     this.$store.dispatch("system/changeTheme", "theme-light");
    //     bodyClass.classList.remove("theme-dark");
    //     bodyClass.classList.add("theme-light");
    //   } else {
    //     this.$store.dispatch("system/changeTheme", "theme-dark");
    //     bodyClass.classList.remove("theme-light");
    //     bodyClass.classList.add("theme-dark");
    //   }
    // },
    setUpPaymentDevice() {
      this.$loading = true;
      if (this.state.system.paymentDeviceDetails != "") {
        this.$loading = false;
        this.$store.commit("setUpPaymentDevice", "");
      } else {
        let data = {
          api_token: this.state.sessions.user.api_token,
          v_id: this.state.user.v_id,
          store_id: this.state.user.store_id,
          vu_id: this.state.user.vu_id,
          trans_from: this.state.system.trans_from,
          serial_number: this.payment_device.serial,
          terminal_id: this.state.system.settings.terminal_id,
          url: "/edc/update-udid",
        };
        axios
          .post(data.url, data)
          .then((res) => {
            if (res.data.status == "success") {
              this.$store.commit("system/setUpPaymentDevice", res.data.data);
              let alertData = {
                message: res.data.message,
                type: "success",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
              this.payment_device.serial = "";
            } else if (res.data.status == "fail") {
              this.payment_device.error = res.data.message;
            }
            this.$loading = false;
          })
          .catch(() => {
            this.$loading = false;
            // this.$loading = false;
          });
      }
    },
    clearError() {
      this.payment_device.error = "";
    },
    openPortList() {
      qz.serial.findPorts().then((data) => {
        // console.log(data);
        this.portList = data;
      });
      this.$bvModal.show("weighing-scale-modal");
    },
    openPortListPayment() {
      qz.serial.findPorts().then((data) => {
        //  console.log(data);
        this.portList = data;
      });
      this.$bvModal.show("mp200-modal");
    },
    setPort(port) {
      // let delims = {
      //   start: "",
      //   end: "",
      //   width: null
      // };
      let self = this;
      // qz.serial.openPort(port, delims).then(function() {
      let alertData = {
        message: port + " set successfully !",
        type: "success",
      };
      self.$showAlert = true;
      self.$store.commit("notifications/showAlert", alertData);
      self.$store.commit("system/saveWeightPort", port);
      self.$store.commit("system/clearPluData");
      self.$bvModal.hide("weighing-scale-modal");
      // });
    },
    setPortForPaymement(port) {
      // let delims = {
      //   start: "",
      //   end: "",
      //   width: null
      // };
      let self = this;
      // qz.serial.openPort(port, delims).then(function() {
      let alertData = {
        message: port + " set successfully !",
        type: "success",
      };
      self.$showAlert = true;
      self.$store.commit("notifications/showAlert", alertData);
      self.$store.commit("system/saveMp200Port", port);
      self.$bvModal.hide("mp200-modal");
      // });
    },
    openKeyboardModal() {
      this.openShortcuts = true;
    },
    hideKeyboardModal() {
      this.openShortcuts = false;
    },
    async isStoragePersisted() {
      let storage =
        (await navigator.storage) && navigator.storage.estimate
          ? navigator.storage.estimate()
          : undefined;
      storage.then((val) => {
        this.offline.storageSummry = val;
      });
    },
    bytesToSize(bytes) {
      let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      // console.log(i);
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    syncTable(val) {
      this.isLoad = true;
      this.isIndex = val;

      // let doc = document.getElementById(val).classList.add("active");
      // console.log(doc);

      let date_time = {};
      date_time.data = this.$moment().format("MMMM Do YYYY, h:mm:ss A");
      date_time.index = val;
      this.$store.commit("offline/setDate", date_time);
      // this.$refs["synced-modal"].show();

      let self = this;
      if (val == 0) {
        // socket.closeConn();
        this.$store.commit("system/setSocketConnection", false);
        // self.syncUserTable();
        // self.syncSessionTable();
        self.syncUserWiseSettingsTable();
      } else if (val == 1) {
        self.syncOfflineStoreProducts();
      } else if (val == 2) {
        // self.syncUserWiseSettingsTable();
      }
    },
    async syncUserTable() {
      await this.$store
        .dispatch("offline/saveOfflineStoreUser")
        .then(() => {
          this.$store.commit("system/setSocketConnection", true);
          this.isLoad = false;
          this.isIndex = "";
        })
        .catch(() => {
          this.$store.commit("system/setSocketConnection", true);
          this.isLoad = false;
          this.isIndex = "";
        });
    },

    async syncSessionTable() {
      await this.$store
        .dispatch("offline/saveOfflineSession")
        .then(() => {
          this.$store.commit("system/setSocketConnection", true);
          this.isLoad = false;
          this.isIndex = "";
        })
        .catch(() => {
          this.$store.commit("system/setSocketConnection", true);
          this.isLoad = false;
          this.isIndex = "";
        });
    },
    async syncUserWiseSettingsTable() {
      await this.$store
        .dispatch("offline/saveUserWiseSettings")
        .then(() => {
          // this.$bvModal.hide("synced-modal");
          this.syncUserTable();
          this.syncSessionTable();
        })
        .catch(() => {
          this.$store.commit("system/setSocketConnection", true);
          this.isLoad = false;
          this.isIndex = "";
        });
    },
    async syncOfflineStoreProducts() {
      await this.$store
        .dispatch("offline/saveOfflineStoreProducts")
        .then(() => {
          // this.isIndex = "";
          // this.$bvModal.hide("synced-modal");
          this.isLoad = false;
        })
        .catch(() => {
          this.isLoad = false;
          // let alertData = {
          //   message: msg.INTERNAL_SERVER_ERROR,
          //   type: "danger"
          // };
          // this.$showAlert = true;
          // this.$store.commit("notifications/showAlert", alertData);
        });
    },
    revokeLicenseCondition() {
      let order = [];
      let session = [];
      db.transaction("rw", db.order, db.session, async () => {
        order = await db.order
          .orderBy("id")
          .and((filter) => {
            return filter.sync == 0 && filter.status == "success";
          })
          .toArray();
        session = await db.session
          .orderBy("id")
          .and((filter) => {
            return (
              filter.sync == 0 &&
              parseInt(filter.vu_id) == parseInt(this.state.sessions.user.vu_id)
            );
          })
          .toArray();
      }).then(() => {
        if (order.length > 0 || session.length > 0) {
          this.$refs["sync-data"].show();
        } else {
          this.$refs["revoke"].show();
        }
      });
    },
    openSyncTab() {
      this.$refs["sync-data"].hide();
      let tabs = document.getElementsByClassName("nav-link");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].innerHTML == "Sync Data") {
          this.tabIndex = i;
          return;
        }
      }
    },
    fetchUserInfo() {
      this.first_name = this.state.sessions.user.first_name;
      this.last_name = this.state.sessions.user.last_name;
      this.dob = this.state.sessions.user.dob;
      this.gender = this.checkEmpty(this.state.sessions.user.gender)
        ? ""
        : this.state.sessions.user.gender;
      this.currency = this.state.system.settings.vendor_login_details.hasOwnProperty(
        "currency"
      )
        ? this.state.system.settings.vendor_login_details.currency.name
        : "Indian Rupee";
      this.timezone = this.state.system.settings.setting_date_time.hasOwnProperty(
        "time_zone"
      )
        ? this.state.system.settings.setting_date_time.time_zone
        : "Indian Standard Time";
    },
    toggleScanMode() {
      this.$store.commit(
        "system/setScanOnlyMode",
        !this.state.system.scan_only_mode
      );
    },
    logoutNav() {
      document.getElementById("logout_btn_nav").click();
    },
    printHandler() {
      this.$store.commit(
        "billing/setAutoPrint",
        !this.state.billing.auto_print_enable
      );
    },
    getStateList() {
      if (this.state.system.isOffline) return;
      this.$store.dispatch("extra/saveStates");
    },
  },
};
</script>
<style lang="scss" scoped>
.sync .progress {
  height: 5px;
}
.card > .list-group .list-group-item {
  border-radius: 4px;
}
.storage .col-md-3 p {
  color: #a0a0aa;
}
.storage .col-md-3 p span {
  color: #000;
}
.theme-dark .storage .col-md-3 p span {
  color: #ccc;
}
.theme-dark .text-success {
  color: $green-color !important;
}
.usage .dot {
  height: 12px;
  width: 12px;
  background-color: $primary-color;
  border-radius: 50%;
  display: inline-block;
  border: 1px $primary-color solid;
  margin-right: 10px;
}
.dot {
  height: 12px;
  width: 12px;
  background-color: #fafafa;
  border: 1px #dddbdb solid;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}
.theme-change {
  img {
    border-radius: 5px;
  }
  img.active {
    border: 6px solid $blue-color;
  }
  img {
    border: 6px solid transparent;
  }
  h5:not(.active-light) {
    color: $secondary-bg-btn;
    &.active-dark {
      color: $white-color;
    }
  }
}

.left-side {
  height: calc(100vh - 69px);
  overflow: hidden;
}
label {
  font-size: 12px;
  padding-left: 10px;
}
.theme-dark label {
  color: #c0c0c0 !important;
}
label::placeholder {
  font-weight {
    font-weight: 400;
  }
}
.grey-btn {
  border-radius: 0.25rem;
  padding: 0.675rem 1rem !important;
  color: #fff;
  font-weight: 400;
  font-size: 0.8125rem;
  width: 140px;
}
.quick-actions {
  .disabled {
    cursor: no-drop;
  }
}

input {
  font-size: 0.8125rem;
  height: calc(2.55rem + 0px);
  border-radius: 0.3rem !important;
}
.left-side .form-group {
  margin-bottom: 0px;
}

.input-group-prepend {
  margin-right: -1px;
  /* float: right; */
  position: absolute;
  right: 0;
  z-index: 9;
  bottom: 0;
  background-color: transparent !important;
  top: 0;
}
.input-group-prepend .input-group-text {
  background: transparent;
  border: none;
}
.left-side .form-control {
  background-color: #f0f0f0;
  border: 1px solid #ced4da;
}
.theme-light .left-side .form-control:focus {
  background-color: #fff;
  border: 1px solid #ced4da;
}

.left-side select {
  height: calc(2.55rem + 2px) !important;
}
.left-side .input[type="text"] {
  height: calc(2.55rem + 2px) !important;
}
.vdp-datepicker input {
  height: calc(2.55rem + 0px);
}

.theme-dark .modal-body p {
  color: #fff;
}
.theme-dark .modal-body p + p {
  color: #c0c0c0;
  margin-bottom: 30px;
}
.header-elements .btn {
  display: inline-flex;
}
.btn .on-hover {
  display: none;
}
.btn .out-hover {
  display: block;
  margin-top: 4px;
}
.btn:hover .on-hover {
  display: block;
  margin-top: 4px;
}
.btn:hover .out-hover {
  display: none;
}
.theme-dark .setting .vdp-datepicker :read-only {
  background-color: #303030 !important;
}
.form-control.is-valid {
  background-image: none !important;
}
.form-control.is-invalid {
  background-image: none !important;
}
form .error {
  font-size: 0.725rem !important;
  color: #cc6666 !important;
  padding-top: 10px;
}
.license p {
  font-size: 12px !important;
  color: #808080 !important;
}
.theme-dark .license p {
  color: #c0c0c0 !important;
}
.theme-dark {
  .usage {
    .dot {
      background-color: #4fb0ad;
      border: 1px #4fb0ad solid;
    }
  }
  .dot {
    background-color: #404040;
    border: 1px #404040 solid;
  }
  .content p {
    color: #fff !important;
  }
}
.license h6 {
  font-size: 14px !important;
  color: #fff;
  font-weight: 400;
}
.license h6 {
  font-size: 15px !important;
  color: #fff !important;
  font-weight: 400 !important;
  padding: 0px !important;
}
.license .days-count {
  height: 100px;
  width: 100px;
  border-radius: 5px;
  background-color: #404040;
  position: relative;
  transform: rotate(-90deg);
}
.theme-light .license .days-count {
  background-color: #f0f0f0;
}
.theme-light .license h6 {
  color: #404040 !important;
}
.theme-light .license p {
  color: #808080;
}
.theme-light .content p,
.theme-light .content h6 {
  color: #404040 !important;
}

.license .content {
  position: absolute;
  top: 40px;
  left: 30px;
}
.theme-dark .modal-body p {
  color: #c0c0c0 !important;
}

.theme-dark .modal-body .grey-outline-btn {
  border: 1px #606060 solid;
  background-color: transparent !important;
  color: #606060;
  width: 120px;
}
.theme-dark .modal-body .grey-outline-btn:hover {
  background-color: #606060 !important;
  color: #fff;
}
.theme-dark h5 {
  color: #fff;
}
h5 {
  font-weight: 500;
}
.warning {
  margin-left: -60px;
}
.quick-actions {
  background: $body-color-light;
  margin-left: -20px;
  margin-right: -20px;
  height: 78vh;
  overflow: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
  box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  .card {
    background: transparent;
    border: 0;

    .list-group {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      :hover {
        cursor: pointer;
      }
    }
  }
  h5 {
    font-size: 15px;
  }
}
.theme-dark .sync {
  background: #000;
}
.sync {
  background: $body-color-light;
  margin-left: -20px;
  height: calc(100vh - 250px);
  overflow-y: auto;
  @include custom-scrollbar();
  margin-right: -20px;
  .card {
    background: transparent;
    border: 0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
    .list-group {
      padding: 0px;
      border-radius: 4px;
      &:hover {
        cursor: inherit;
      }
      a:hover {
        cursor: pointer;
      }
    }
  }
  h5 {
    font-size: 15px;
  }
}
.theme-dark {
  .quick-actions {
    background: #000000;
  }
  .list-group-item {
    background: #202020 !important;
  }
  .setting .left-side .tab-content .card-body p {
    font-size: inherit;
  }
  .storage .progress {
    background-color: #404040;
  }
}
@media only screen and (max-width: 1025px) {
  .warning {
    margin-left: 0px;
  }
}
.btn.btn-port {
  padding: 8px 15px !important;
}
.storage .progress {
  background-color: #f0f0f0;
}
.cursor-default {
  cursor: default !important;
}
</style>
